import React from 'react';
import TabContainer from '../../../../../../../../common/components/tab/containers/tab.containers';
import BrandMappingLogoInfoComponent from './brand-mapping-logo-favicon-info.component';
import BrandMappingcolorInfoComponent from './brand-mappings-color-info.component';
import BrandMappingStoriesInfoComponent from './brand-mapping-strory-info.component';
import BrandMappingBasicInfoComponent from './brand-mapping-basic-Info.component';

export const BrandMappingInfoComponent = ({ websites, webpages,
    changeFavImage, changeLogoImage, brandMappings, faviconSize, logoBackground, logoFiles,
    onFormItemBrandChange, onFormLogoItemChange, onFormFavItemChange, handleClose, back, handleFormSubmit
}: any) => {

    const tabItems = [
        {
            id: 1,
            title: 'Basic Information',
            component: <BrandMappingBasicInfoComponent
                onFormItemBrandChange={onFormItemBrandChange}
                brandMappings={brandMappings}
                websites={websites}
                webpages={webpages}
            />,
            isVisible: true,
        },
        {
            id: 2,
            title: 'Logo and Favicon Info',
            component: <BrandMappingLogoInfoComponent
                handleClose={handleClose}
                onFormItemBrandChange={onFormItemBrandChange}
                logoFiles={logoFiles}
                changeFavImage={changeFavImage}
                onFormLogoItemChange={onFormLogoItemChange}
                faviconSize={faviconSize}
                changeLogoImage={changeLogoImage}
                logoBackground={logoBackground}
                brandMappings={brandMappings}
                onFormFavItemChange={onFormFavItemChange}
            />,
            isVisible: true,
        },
        {
            id: 3,
            title: ' color information',
            component: <BrandMappingcolorInfoComponent
                onFormItemBrandChange={onFormItemBrandChange}
                brandMappings={brandMappings}
            />,
            isVisible: true,
        },
        {
            id: 4,
            title: 'Branding Stories Info',
            component: <BrandMappingStoriesInfoComponent

                onFormItemBrandChange={onFormItemBrandChange}
                brandMappings={brandMappings}

            />,
            isVisible: true,
        },

    ]

    return (
        <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">

            <TabContainer tabItems={tabItems} />

            {/* <div className='flex w-full justify-end items-end'>
                <button
                    onClick={back}
                    type='button'
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                >
                    Back
                </button>
                <button
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                    onClick={handleFormSubmit}
                    type="submit"
                >
                    Save
                </button> */}
            {/* </div> */}
        </div>
    )
}

export default BrandMappingInfoComponent;
